import { render, staticRenderFns } from "./dev-table.vue?vue&type=template&id=4e2a4d2c"
import script from "./dev-table.vue?vue&type=script&lang=ts"
export * from "./dev-table.vue?vue&type=script&lang=ts"
import style0 from "./dev-table.vue?vue&type=style&index=0&id=4e2a4d2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports